export const normalizeApiBase = (value?: string): string => {
  const configuredBase = value?.trim();
  return configuredBase ? configuredBase.replace(/\/+$/, '') : '';
};

// Same-origin is the safe default: Vite proxies /api locally and production can
// route /api to the backend without making a visitor's browser call localhost.
export const API_BASE = normalizeApiBase(import.meta.env.VITE_API_BASE_URL);

export const AUTH_REQUEST_TIMEOUT_MS = 30_000;
